module.exports = __webpack_public_path__ + "static/img/tryout_bc_01_zh.ff5a883.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tryout_bc_01_zh.png
// module id = vqGb
// module chunks = 34